import { useContext } from "react";

import UserProfileContext from "../context/UserProfileContext";

const useUserProfile = () => useContext(UserProfileContext);

export default useUserProfile;
